export default __webpack_public_path__ + "static/media/airport.97ec18d1.svg";